import AxiosRequestBuilder from '@/utils/axios-request-builder'
import { Endpoints, urlBuilder } from '@/connectors/endpoints'
import { mapper } from '@/mappers'
import reverseObjUtil from '@/utils/reverse-obj.util'
import { IAccruals, ICreateAccruals } from '@/types/accruals'
import { createAccrualMap } from '@/mappers/accruals'

const createAccrual = (formData: ICreateAccruals) => {
  return new AxiosRequestBuilder<IAccruals>({
    url: urlBuilder(Endpoints.CREATE_ACCRUALS),
    method: 'post',
    data: formData,
    requestMapperFunction: mapper,
    requestMapper: reverseObjUtil(createAccrualMap)
  }).exec()
}

export default createAccrual
